export const emptyStateErrorMessages = [
  'gmlResponse is empty',
  'responseContainer is empty'
]
